// extracted by mini-css-extract-plugin
export var errorIcon = "_kk-1";
export var nameLogo = "_kk-0";